



























import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class ResearchComposeSizhenhecan extends Vue {
  @Prop()
  private message: any;
}
